import { Store } from '@ngrx/store';
// Constants
import { ASC } from 'NewAngular/constants/core.constants';
import { RISK_PROFILES_FEATURE, TALKING_POINTS_FEATURE, TRANSITION_ANALYSIS_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { CustomPdfReportDataSourceEnum } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-data-source.enum';
import { TalkingPointsListPageSortColumn } from 'TalkingPointsApp/apps/talking-points-list-app/enums/talking-points-list.enum';
// Selectors
import { getSelectedReport, getWizardStepEventName, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
// Reducers
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
// Components
import { CoverPageModuleModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/cover-page-modal/cover-page-module-modal.component';
import { CustomPdfReportFolderModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/custom-pdf-report-folder-modal/custom-pdf-report-folder-modal.component';
import { EditTalkingPointsModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/edit-talking-points-modal/edit-talking-points-modal.component';
import { EditCustomTextModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/edit-custom-text-modal/edit-custom-text-modal.component';
import { ExportOptionsModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/export-options-modal/export-options-modal.component';
import { GenerateReportModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-report-modal/generate-report-modal.component';
import { ReportAnalysisPlanSelectorModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-analysis-plan-selector-modal/report-analysis-plan-selector-modal.component';
import { ReportSecuritySearchModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/report-security-search-modal.component';
import { ReportHypotheticalSelectorModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-hypothetical-selector-modal/report-hypothetical-selector-modal.component';
import { DollarConversionLevelSelectorModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/dollar-conversion-level-selector-modal/dollar-conversion-level-selector-modal.component';
import { SelectTransitionAnalysisModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-transition-analysis-modal/select-transition-analysis-modal.component';
import { SelectSectionsModalComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-sections-modal/select-sections-modal.component';
import { TalkingPointsEditModalComponent } from 'TalkingPointsApp/features/talking-points-edit-modal/talking-points-edit-modal.component';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { TalkingPointsService } from 'TalkingPointsApp/services/talking-points.service';
import { ModelPortfoliosService } from 'ModelPortfolioApp/ts/shared/services/model-portfolios.service';
import { RiskProfilesService } from 'RiskProfilesApp/services/risk-profiles.service';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "RiskProfilesApp/services/risk-profiles.service";
import * as i3 from "TalkingPointsApp/services/talking-points.service";
import * as i4 from "ModelPortfolioApp/ts/shared/services/model-portfolios.service";
import * as i5 from "@ngrx/store";
import * as i6 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/cover-page-modal/cover-page-module-modal.component";
import * as i7 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/custom-pdf-report-folder-modal/custom-pdf-report-folder-modal.component";
import * as i8 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/dollar-conversion-level-selector-modal/dollar-conversion-level-selector-modal.component";
import * as i9 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/edit-custom-text-modal/edit-custom-text-modal.component";
import * as i10 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/edit-talking-points-modal/edit-talking-points-modal.component";
import * as i11 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/export-options-modal/export-options-modal.component";
import * as i12 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-report-modal/generate-report-modal.component";
import * as i13 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-analysis-plan-selector-modal/report-analysis-plan-selector-modal.component";
import * as i14 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-hypothetical-selector-modal/report-hypothetical-selector-modal.component";
import * as i15 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/report-security-search-modal.component";
import * as i16 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-risk-profile-modal/select-risk-profile-modal.component";
import * as i17 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-risk-profile-model-portfolio-modal/select-risk-profile-model-portfolio-modal.component";
import * as i18 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-sections-modal/select-sections-modal.component";
import * as i19 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-transition-analysis-modal/select-transition-analysis-modal.component";
export class PdfModalWrapperComponent {
    constructor(featureService, riskProfileService, talkingPointsService, modelPortfoliosService, store) {
        this.featureService = featureService;
        this.riskProfileService = riskProfileService;
        this.talkingPointsService = talkingPointsService;
        this.modelPortfoliosService = modelPortfoliosService;
        this.store = store;
        this.customPDFReportBuilderStore = null;
        this.wizardStepEventName = '';
        this.riskProfiles = [];
        this.talkingPointsDataMap = {};
        this.transitionAnalysisList = [];
        this.defaultOnly = false;
        this.mapStateToComponent = (state) => {
            this.wizardStepEventName = getWizardStepEventName(state);
            const selectedReport = getSelectedReport(state);
            const updatedDataSource = 'data_source' in selectedReport ? selectedReport.data_source : '';
            const dataSourceChanged = updatedDataSource && updatedDataSource !== this.dataSource;
            if (dataSourceChanged) {
                this.defaultOnly = updatedDataSource !== CustomPdfReportDataSourceEnum.LEGACY;
            }
            if (dataSourceChanged && this.featureService.userHasFeatures([RISK_PROFILES_FEATURE])) {
                this.riskProfileService.getRiskProfiles(updatedDataSource).subscribe({
                    next: (response) => {
                        this.riskProfiles = response;
                    },
                });
            }
            if (dataSourceChanged && this.featureService.userHasFeatures([TALKING_POINTS_FEATURE])) {
                this.fetchTalkingPoints(updatedDataSource).subscribe({
                    next: (items) => {
                        this.talkingPointsDataMap = Object.fromEntries(items.map((tp) => [tp.id.toString(), tp]));
                    },
                });
            }
            this.dataSource = updatedDataSource;
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnInit() {
        if (this.featureService.userHasFeatures([TALKING_POINTS_FEATURE])) {
            this.fetchTalkingPoints(this.dataSource).subscribe({
                next: (items) => {
                    this.talkingPointsDataMap = Object.fromEntries(items.map((tp) => [tp.id.toString(), tp]));
                },
            });
        }
        if (this.featureService.userHasFeatures([RISK_PROFILES_FEATURE])) {
            this.riskProfileService.getRiskProfiles().subscribe({
                next: (response) => {
                    this.riskProfiles = response;
                },
            });
        }
        if (this.featureService.userHasFeatures([TRANSITION_ANALYSIS_FEATURE])) {
            this.modelPortfoliosService.getTransitionAnalysisList().subscribe({
                next: (response) => {
                    this.transitionAnalysisList = response;
                },
            });
        }
    }
    ngOnDestroy() {
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
    }
    broadcastEvent() {
        switch (this.wizardStepEventName) {
            case CustomPDFReportModalEventName.SHOW_REPORT_MENU_MODAL:
                this.customPdfReportFolderModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL:
                this.reportSecuritySearchModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_COVER_PAGE_MODULE_MODAL:
                this.coverPageModal.openModal();
                break;
            case CustomPDFReportModalEventName.GENERATE_CUSTOM_PDF_REPORT:
                this.generateReportModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SELECT_SAVED_HYPOTHETICAL_MODAL:
                this.reportHypotheticalSelectorModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL:
                this.reportAnalysisPlanSelectorModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_EDIT_TALKING_POINTS_MODAL:
                this.editTalkingPointsModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_EDIT_CUSTOM_TEXT_MODAL:
                this.editCustomTextModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SELECT_DOLLAR_CONVERSION_LEVEL_MODAL:
                this.dollarConversionLevelSelectorModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SELECT_SECTIONS_MODAL:
                this.selectSectionsModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_SELECT_TRANSITION_ANALYSIS_MODAL:
                this.selectTransitionAnalysisModal.openModal();
                break;
            case CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL:
                this.exportOptionsModal.openModal();
                break;
            default:
                break;
        }
    }
    fetchTalkingPoints(dataSource) {
        this.defaultOnly = dataSource !== CustomPdfReportDataSourceEnum.LEGACY;
        const params = {
            owner: 'me:::true,,,public:::true,,,shared_with_me:::true',
            metric: null,
            name: '',
            sortColumn: TalkingPointsListPageSortColumn.NAME,
            sortDirection: ASC,
            viewRootFolder: null,
            includeEmptyFolders: false,
            includeLegacy: !this.defaultOnly,
        };
        return this.talkingPointsService.getTalkingPointsModalList(params);
    }
}
PdfModalWrapperComponent.ɵfac = function PdfModalWrapperComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PdfModalWrapperComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.RiskProfilesService), i0.ɵɵdirectiveInject(i3.TalkingPointsService), i0.ɵɵdirectiveInject(i4.ModelPortfoliosService), i0.ɵɵdirectiveInject(i5.Store)); };
PdfModalWrapperComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PdfModalWrapperComponent, selectors: [["ycn-pdf-modal-wrapper"]], viewQuery: function PdfModalWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CustomPdfReportFolderModalComponent, 5);
        i0.ɵɵviewQuery(ReportSecuritySearchModalComponent, 5);
        i0.ɵɵviewQuery(CoverPageModuleModalComponent, 5);
        i0.ɵɵviewQuery(GenerateReportModalComponent, 5);
        i0.ɵɵviewQuery(ReportHypotheticalSelectorModalComponent, 5);
        i0.ɵɵviewQuery(ReportAnalysisPlanSelectorModalComponent, 5);
        i0.ɵɵviewQuery(EditTalkingPointsModalComponent, 5);
        i0.ɵɵviewQuery(EditCustomTextModalComponent, 5);
        i0.ɵɵviewQuery(ExportOptionsModalComponent, 5);
        i0.ɵɵviewQuery(DollarConversionLevelSelectorModalComponent, 5);
        i0.ɵɵviewQuery(SelectSectionsModalComponent, 5);
        i0.ɵɵviewQuery(SelectTransitionAnalysisModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customPdfReportFolderModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportSecuritySearchModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coverPageModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.generateReportModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportHypotheticalSelectorModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportAnalysisPlanSelectorModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editTalkingPointsModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editCustomTextModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.exportOptionsModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dollarConversionLevelSelectorModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectSectionsModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectTransitionAnalysisModal = _t.first);
    } }, inputs: { customTalkingPointsEditModal: "customTalkingPointsEditModal", customPDFReportBuilderStore: "customPDFReportBuilderStore" }, standalone: false, decls: 14, vars: 6, consts: [[3, "broadcastWizardStepEvent"], [3, "broadcastWizardStepEvent", "customPDFReportBuilderStore"], [3, "broadcastWizardStepEvent", "customTalkingPointsEditModal", "talkingPointsDataMap", "defaultOnly"], [3, "broadcastWizardStepEvent", "riskProfiles"], [3, "broadcastWizardStepEvent", "transitionAnalysisList"]], template: function PdfModalWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-custom-pdf-report-folder-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_custom_pdf_report_folder_modal_broadcastWizardStepEvent_0_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "ycn-report-security-search-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_report_security_search_modal_broadcastWizardStepEvent_1_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "ycn-cover-page-module-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_cover_page_module_modal_broadcastWizardStepEvent_2_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "ycn-export-options-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_export_options_modal_broadcastWizardStepEvent_3_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-generate-report-modal", 1);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_generate_report_modal_broadcastWizardStepEvent_4_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-report-hypothetical-selector-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_report_hypothetical_selector_modal_broadcastWizardStepEvent_5_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ycn-report-analysis-plan-selector-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_report_analysis_plan_selector_modal_broadcastWizardStepEvent_6_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "ycn-edit-talking-points-modal", 2);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_edit_talking_points_modal_broadcastWizardStepEvent_7_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-edit-custom-text-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_edit_custom_text_modal_broadcastWizardStepEvent_8_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "ycn-dollar-conversion-level-selector-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_dollar_conversion_level_selector_modal_broadcastWizardStepEvent_9_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "ycn-select-risk-profile-modal", 3);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_select_risk_profile_modal_broadcastWizardStepEvent_10_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ycn-select-risk-profile-model-portfolio-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_select_risk_profile_model_portfolio_modal_broadcastWizardStepEvent_11_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ycn-select-sections-modal", 0);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_select_sections_modal_broadcastWizardStepEvent_12_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "ycn-select-transition-analysis-modal", 4);
        i0.ɵɵlistener("broadcastWizardStepEvent", function PdfModalWrapperComponent_Template_ycn_select_transition_analysis_modal_broadcastWizardStepEvent_13_listener() { return ctx.broadcastEvent(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("customPDFReportBuilderStore", ctx.customPDFReportBuilderStore);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("customTalkingPointsEditModal", ctx.customTalkingPointsEditModal)("talkingPointsDataMap", ctx.talkingPointsDataMap)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("riskProfiles", ctx.riskProfiles);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("transitionAnalysisList", ctx.transitionAnalysisList);
    } }, dependencies: [i6.CoverPageModuleModalComponent, i7.CustomPdfReportFolderModalComponent, i8.DollarConversionLevelSelectorModalComponent, i9.EditCustomTextModalComponent, i10.EditTalkingPointsModalComponent, i11.ExportOptionsModalComponent, i12.GenerateReportModalComponent, i13.ReportAnalysisPlanSelectorModalComponent, i14.ReportHypotheticalSelectorModalComponent, i15.ReportSecuritySearchModalComponent, i16.SelectRiskProfileModalComponent, i17.SelectRiskProfileModelPortfolioModalComponent, i18.SelectSectionsModalComponent, i19.SelectTransitionAnalysisModalComponent], encapsulation: 2 });
